import {LAYER_SUBTYPE} from "@frontend/components/modules/layouts-page/modals/layout-preview/constants";
import {settingFlag, settingNumber, settingRaw} from "./template-settings";

/**
 * @type FieldMapper
 */
export const backgroundThemeImageMapper = ({
  templateSettings,
  index
}) => {
  return {
    src: settingRaw(templateSettings, 'background', index),
    angle: settingNumber(templateSettings, 'bk_img_angle', index),
    flipX: settingFlag(templateSettings, 'bk_img_flipX', index),
    flipY: settingFlag(templateSettings, 'bk_img_flipY', index),
    scale: settingNumber(templateSettings, 'bk_img_scale', index, 1),
    width: settingNumber(templateSettings, 'bk_img_width', index),
    height: settingNumber(templateSettings, 'bk_img_height', index),
    subType: LAYER_SUBTYPE.IMAGE
  };
}
